<template>
  <div class=" section-nucleo-icons">
    <div class="container">
      <div class="row sectionBox">
        <div class="col-lg-6 col-md-12">
          <h3 class="title">Explorer</h3>
          <h4 class="description">
            Want to identify customer locations without having any technical resources? Simply browse using the Crowdify Event Explorer!
          </h4>
          <!-- <div class="nucleo-container">

                </div> -->

          <!--
          <a
            href="https://demos.creative-tim.com/now-ui-kit/nucleo-icons.html"
            class="btn btn-primary btn-round btn-lg"
            target="_blank"
            >View Demo Icons</a
          >
          <a
            href="https://nucleoapp.com/?ref=1712"
            class="btn btn-primary btn-simple btn-round btn-lg"
            target="_blank"
            >View All Icons</a
          >-->
        </div>
        <div class="col-lg-6 col-md-12">
          <img v-lazy="'img/map.jpg'" alt="" style="padding:20px">
        </div>
      </div>
    </div>
  </div>


</template>




<script>
export default {};
</script>
<style>
.sectionBox{
  background: rgb(242, 242, 242);
  border-radius: .8em;
}
</style>
